import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "User_Profile.6",
	"data-name": "User,Profile.6",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14024",
		"data-name": "Group 14024",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11630",
				"data-name": "Path 11630",
				d: "M10.091,8.159a2.25,2.25,0,1,1-3.182,0,2.25,2.25,0,0,1,3.182,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11631",
				"data-name": "Path 11631",
				d: "M2,18.5V5.541A2.041,2.041,0,0,1,4.041,3.5H20a2,2,0,0,1,2,2v13a2,2,0,0,1-2,2H4A2,2,0,0,1,2,18.5Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11632",
				"data-name": "Path 11632",
				d: "M15,9.5h4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11633",
				"data-name": "Path 11633",
				d: "M17.4,13.5H15",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11634",
				"data-name": "Path 11634",
				d: "M12.1,16.5a3.17,3.17,0,0,0-.792-1.154h0A3.173,3.173,0,0,0,9.146,14.5H7.854a3.173,3.173,0,0,0-2.157.846h0A3.17,3.17,0,0,0,4.905,16.5",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11635",
		"data-name": "Path 11635",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgStep3;
